"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var QuestionIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(QuestionIcon, _React$PureComponent);

  function QuestionIcon() {
    _classCallCheck(this, QuestionIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(QuestionIcon).apply(this, arguments));
  }

  _createClass(QuestionIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className"]);
      /* eslint-disable max-len */


      var svg = {
        small: {
          // TODO: path and viewBox are not the right ones, it's a temporary
          // version based on the medium one shrinked to 8x8 with CSS
          // need to pick the exact unique shape once provided by the design team
          // #ENG-162166
          // viewBox: '0 0 8 8',
          viewBox: '0 0 12 12',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M6.5,7 C6.5,7.55228475 6.05228475,8 5.5,8 C4.94771525,8 4.5,7.55228475 4.5,7 L4.5,6.23181843 C4.5,5.5887231 4.98795196,5.05054452 5.62787539,4.98780017 C7.35723242,4.8180065 8,4.33059022 8,3.5 C8,1.9548699 4.8922442,1.50403287 3.77675575,2.87980196 C3.42892573,3.30879231 2.79918839,3.37458577 2.37019804,3.02675575 C1.94120769,2.67892573 1.87541423,2.04918839 2.22324425,1.62019804 C4.38313985,-1.04367319 10,-0.22884451 10,3.5 C10,5.36908343 8.72147503,6.50474686 6.5,6.88767491 L6.5,7 Z"
          }), _react.default.createElement("rect", {
            fill: color,
            x: "4.30000019",
            y: "9.39999962",
            width: "2.4000001",
            height: "2.5999999",
            rx: "1.20000005"
          }))
        },
        medium: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M6.5,7 C6.5,7.55228475 6.05228475,8 5.5,8 C4.94771525,8 4.5,7.55228475 4.5,7 L4.5,6.23181843 C4.5,5.5887231 4.98795196,5.05054452 5.62787539,4.98780017 C7.35723242,4.8180065 8,4.33059022 8,3.5 C8,1.9548699 4.8922442,1.50403287 3.77675575,2.87980196 C3.42892573,3.30879231 2.79918839,3.37458577 2.37019804,3.02675575 C1.94120769,2.67892573 1.87541423,2.04918839 2.22324425,1.62019804 C4.38313985,-1.04367319 10,-0.22884451 10,3.5 C10,5.36908343 8.72147503,6.50474686 6.5,6.88767491 L6.5,7 Z"
          }), _react.default.createElement("rect", {
            fill: color,
            x: "4.30000019",
            y: "9.39999962",
            width: "2.4000001",
            height: "2.5999999",
            rx: "1.20000005"
          }))
        }
      }[size];
      /* eslint-enable max-len */

      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'question-icon'),
        viewBox: svg.viewBox,
        size: size
      }, props), svg.path);
    }
  }]);

  return QuestionIcon;
}(_react.default.PureComponent);

exports.default = QuestionIcon;
QuestionIcon.defaultProps = {
  size: 'medium',
  color: 'inherit'
};
QuestionIcon.propTypes = {
  size: _propTypes.default.oneOf(['medium', 'small']),
  className: _propTypes.default.string,
  color: _propTypes.default.string
};